module.exports = __webpack_public_path__ + "img/2024-02-13e_3.c8196345.jpg";